"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createModalStyle = exports.DESIGN_SYSTEM = void 0;
var react_1 = require("@emotion/react");
exports.DESIGN_SYSTEM = 'design-system';
var createModalStyle = function (theme) { return ({
    backdropStyle: react_1.css({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.name === exports.DESIGN_SYSTEM ? 'rgba(0, 0, 0, .6)' : 'rgba(55, 55, 55, .6)',
        overflow: 'auto',
        zIndex: theme.zIndex.MODAL,
    }),
    gridStyle: react_1.css({
        width: '100%',
        height: '100%',
    }),
}); };
exports.createModalStyle = createModalStyle;
